import { createAction } from "redux-actions";
import { takeLatest, put, select, call } from "redux-saga/effects";
import dayjs from "dayjs";
import { api } from "../api";
import { API_DATE_FORMAT } from "../../../../app_constants";

export const SET_LOADING = "saga/draft/SET_LOADING";
export const SET_DATES = "saga/draft/SET_DATES";
export const SET_FILTERS_DIRTY = "saga/draft/SET_FILTERS_DIRTY";
export const SET_UPDATES_LOADING = "saga/draft/SET_UPDATES_LOADING";

export const RESET_FILTER = "saga/draft/RESET_FILTERS";

export const FETCH_CURRENT_USER = "saga/draft/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/draft/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_FILTERS_SUCCESS = "saga/draft/FETCH_FILTERS_SUCCESS";
export const FETCH_CHART_SUCCESS = "saga/draft/FETCH_CHART_SUCCESS";

export const UPDATE_DATES = "saga/draft/UPDATE_DATES";
export const UPDATE_CUSTOM_RANGE = "saga/draft/UPDATE_CUSTOM_RANGE";
export const UPDATE_DRAFT_TYPE = "saga/draft/UPDATE_DRAFT_TYPE";
export const UPDATE_DRAFT_ATTEMPT = "saga/draft/UPDATE_DRAFT_ATTEMPT";
export const UPDATE_CHART = "saga/draft/UPDATE_CHART";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateDates: createAction(UPDATE_DATES),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updateDraftType: createAction(UPDATE_DRAFT_TYPE),
  updateDraftAttempt: createAction(UPDATE_DRAFT_ATTEMPT),
  updateData: createAction(UPDATE_CHART),
  resetFilters: createAction(RESET_FILTER)
};

export default function* watcher() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(UPDATE_CHART, updateData);
  yield takeLatest(RESET_FILTER, resetFilters);
}

export function* fetchCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: data.payload
  });

  yield put({ type: SET_LOADING, payload: true });

  yield fetchFilterOptions();
  yield setDates();

  try {
    yield fetchValues();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchFilterOptions() {
  try {
    let { short_url } = yield select((state) => state.commonReducer.commonProps);
    let { data } = yield call(api.getFilters, { params: { short_url } });

    yield put({
      type: FETCH_FILTERS_SUCCESS,
      payload: data
    });
  } catch (err) {
    console.error(err);
  }
}

function* fetchValues() {
  const params = yield getApiParams();

  try {
    let { data } = yield call(api.getValues, { params });

    yield put({
      type: FETCH_CHART_SUCCESS,
      payload: data
    });
  } catch (err) {
    console.error(err);
  }
}

function* getApiParams() {
  let {
    startDate: start_date,
    endDate: end_date,
    draftTypes,
    draftAttempts
  } = yield select((state) => state.draft.selectedFilters);
  let { short_url } = yield select((state) => state.commonReducer.commonProps);

  const draft_types = (draftTypes || []).map((t) => t.id).join(",");
  const draft_attempts = (draftAttempts || []).map((a) => a.id).join(",");

  return { short_url, start_date, end_date, draft_types, draft_attempts };
}

function* setDates() {
  const endDate = yield select((state) => state.draft.currentUser.calendarEndDate);
  const startDate = dayjs(endDate).startOf("month").format(API_DATE_FORMAT);

  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate
    }
  });
}

function* updateData() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  try {
    yield put({ type: SET_FILTERS_DIRTY, payload: false });
    yield fetchValues();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* resetFilters() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });

  yield setDates();

  try {
    yield fetchValues();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}
